import { ButtonHTMLAttributes, ReactNode, forwardRef } from 'react';
import styles from './Button.module.css';

export type ButtonVariant =
	| 'primary'
	| 'cardAction'
	| 'secondary'
	| 'outline'
	| 'danger'
	| 'dangerSolid'
	| 'info'
	| 'warning'
	| 'cancel';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	variant?: ButtonVariant;
	isLoading?: boolean;
	icon?: ReactNode;
	iconPosition?: 'left' | 'right';
	fullWidth?: boolean;
	children: ReactNode;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
	(
		{
			variant,
			isLoading = false,
			icon,
			iconPosition = 'left',
			fullWidth = false,
			disabled,
			className,
			children,
			...props
		},
		ref
	) => {
		const buttonClass = `
    ${styles.button}
    ${variant ? styles[variant] : ''}
    ${fullWidth ? styles.fullWidth : ''}
    ${isLoading ? styles.loading : ''}
    ${className || ''}
  `.trim();

		return (
			<button ref={ref} className={buttonClass} disabled={disabled || isLoading} {...props}>
				{!isLoading && icon && iconPosition === 'left' && (
					<span className={styles.iconLeft}>{icon}</span>
				)}
				{isLoading && <span className={styles.spinner} />}
				<span className={styles.content}>{children}</span>
				{!isLoading && icon && iconPosition === 'right' && (
					<span className={styles.iconRight}>{icon}</span>
				)}
			</button>
		);
	}
);

Button.displayName = 'Button';
